<h3 mat-dialog-title class="title-layout">Edit Variant Status </h3>
<div mat-dialog-content>

  <p>Options for variant status.</p>
  <ol>
    <li> <b>INACTIVE - No work is assigned for the variant.</b>  
            This option is chosen when no work is assigned to the pitch for a given variant and the operator does not move.
    <li> <b>INACTIVE - Operator moves to another pitch.</b> This option is chosen when the operator moves to another pitch for a given variant.
            If this option is chosen, you are required to choose the pitch to which the operator is moving.
    <li> <b>ACTIVE</b> work is expected for the variant.</li>
  </ol>
  

  <form [formGroup]="fg_NonActiveWork" >

    <mat-label>Variant Status Options</mat-label>
    <mat-form-field class="card-dialog">
      <mat-select id="existing-team" matInput cdkTextareaAutosize formControlName="f_NonWorkOption">
            <mat-option *ngFor="let option of nonWorkOptions" [value]="option">
                {{option.display}}
            </mat-option>
        </mat-select> 
    </mat-form-field>

    <div *ngIf="variantOption.move_status">
        <mat-label>Moves to Pitch: <br></mat-label>
        <mat-label><small>Choose the pitch to which the operator moves.</small></mat-label>
        <mat-form-field class="card-dialog">
            <mat-select id="existing-team" matInput cdkTextareaAutosize formControlName="f_MoveToPitch">
                <mat-option *ngFor="let pitch of pitchList" [value]="pitch">
                    {{pitch}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    
  </form>
</div>

<div mat-dialog-actions>
  <button  mat-button color="primary" (click)="onSubmit()">Submit</button>
  <button mat-button (click)="onNoClick()">Cancel</button>
</div>
